import React from 'react';
import { Moon, CheckCircle2, X } from 'lucide-react';
export function ProductSection() {
  return <section className="py-12 md:py-16 bg-warm-200" data-id="element-206">
      <div className="max-w-5xl mx-auto px-4" data-id="element-207">
        <div className="text-center mb-10" data-id="element-208">
          <div className="inline-flex items-center gap-2 mb-3" data-id="element-209">
            <Moon className="w-6 h-6 text-primary-500" data-id="element-210" />
            <h2 className="text-3xl md:text-4xl font-bold text-text-dark" data-id="element-211">
              Noches de Paz
            </h2>
          </div>
          <p className="text-lg text-primary-600 font-medium" data-id="element-212">
            La guía colombiana para que tu bebé duerma 6 a 8 horas seguidas en 7
            días
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-213">
          <div className="order-2 lg:order-1" data-id="element-214">
            <div className="space-y-2 mb-6" data-id="element-215">
              {['No es un curso de $800.000', 'No es una consulta médica de 2 horas', 'No es otro PDF genérico traducido'].map((item, i) => <div key={i} className="flex items-center gap-2 text-text-muted text-sm" data-id="element-216">
                  <X className="w-4 h-4 text-red-400" data-id="element-217" />
                  <span data-id="element-218">{item}</span>
                </div>)}
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-md" data-id="element-219">
              <p className="font-semibold text-text-dark mb-4" data-id="element-220">
                Es un{' '}
                <span className="text-primary-600" data-id="element-221">
                  manual práctico y colombiano
                </span>{' '}
                que podés leer en una siesta.
              </p>

              <p className="text-xs uppercase tracking-wider text-text-muted font-semibold mb-3" data-id="element-222">
                Funciona en:
              </p>

              <ul className="space-y-2" data-id="element-223">
                {['Apartamentos de estrato 2 al 6', 'Casas con ruido de calle o vecinos', 'Bebés de 0 a 18 meses', 'Papás y mamás que trabajan', 'Familias con abuelas "expertas"'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm text-text-body" data-id="element-224">
                    <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-225" />
                    <span data-id="element-226">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-227">
            <img src="https://cdn.magicpatterns.com/uploads/iptFMw5F39ZGoWGhTBekse/portada_2.webp" alt="Noches de Paz - Familia durmiendo" className="w-full max-w-md mx-auto rounded-2xl shadow-xl" data-id="element-228" />
          </div>
        </div>
      </div>
    </section>;
}